// extracted by mini-css-extract-plugin
export default {"btnSubmit":"BtnApplyNewTemplate_btnSubmit__AgOas"};